module.exports = "<p>adminsales works!</p>\n"